module.exports = __webpack_public_path__ + "img/top_logo.59908765.png";